import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./Login.css";
import logo from "../../assets/rankers.jpg";
import { httpRequest } from "../../redux/Action";
import Loader from "../Loader";
import { toast } from "react-toastify";

function Login() {
  const [email, setEmail] = useState("");
  const [localLoading, setLocalLoading] = useState(false)

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ✅ correct reducer usage
  const { loading, error } = useSelector((state) => state.apiReducer.userSendLogin || {});



  const handleLogin = (e) => {
    e.preventDefault();
    setLocalLoading(true);

    dispatch(
      httpRequest({
        key: "userSendLogin",
        data: { email },

        onSuccess: (res) => {
          console.log("OTP Sent:", res);
          setLocalLoading(false)
          toast.success("OTP Sent Successfully 🚀");

          // 🔥 move to verify page
          navigate("/user/verify-otp", { state: { email } });
        },

        onError: (err) => {
          console.log("Error:", err);
          setLocalLoading(false)
          toast.error("Failed to send OTP. Please try again.");
        },
      })
    );
  };

  return (
    <div className="login-page-wrapper d-flex justify-content-center align-items-center min-vh-100 px-3">
      
      <div className="ocean">
        <div className="bubbles"></div>
        <div className="moving-bottle b1"></div>
        <div className="moving-bottle b2"></div>
        <div className="moving-bottle b3"></div>
      </div>

      <div className="glass-overlay"></div>

      <div className="col-12 col-sm-10 col-md-8 col-lg-4 z-index-master">
        <form className="login-card shadow-lg" onSubmit={handleLogin}>

          <div className="logo-wrapper mb-4 text-center">
            <img src={logo} alt="Rankers" className="login-logo shadow" />
          </div>

          <div className="text-center mb-4">
            <h3 className="fw-bold text-white mb-1">Welcome Back</h3>
            <p className="small text-white-50">Login with OTP</p>
          </div>

  {error && (
        <p style={{ color: "red" }}>
          {typeof error === "string" ? error : error?.message}
        </p>
      )}
          {/* EMAIL */}
          <div className="input-group-custom mb-4">
            <label className="small fw-bold text-white-50">Email Address</label>
            <input
              type="email"
              className="form-control login-input"
              placeholder="user@rankers.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-login-primary w-100 py-3 shadow"
            disabled={localLoading}
          >
            {localLoading ? (
              <Loader  />
            ) : (
              "Send OTP"
            )}
          </button>

          <p className="signup text-center mt-4 text-white-50">
            Don’t have an account? <Link to="/user/signup">Sign Up</Link>
          </p>

        </form>
      </div>
    </div>
  );
}

export default Login;